import type { AssistantMessage, AssistantToolUse } from '@ldembalagens/types';
import { create } from 'zustand';

export interface ChatEntry extends AssistantMessage {
  id: string;
  toolsUsed?: AssistantToolUse[];
  error?: boolean;
}

interface AssistantState {
  open: boolean;
  entries: ChatEntry[];
  pending: boolean;
  setOpen: (open: boolean) => void;
  append: (entry: ChatEntry) => void;
  setPending: (pending: boolean) => void;
  clear: () => void;
}

/** Conversa do assistente mantida em memória enquanto a sessão durar (nunca persistida). */
export const useAssistantStore = create<AssistantState>((set) => ({
  open: false,
  entries: [],
  pending: false,
  setOpen: (open) => set({ open }),
  append: (entry) => set((s) => ({ entries: [...s.entries, entry] })),
  setPending: (pending) => set({ pending }),
  clear: () => set({ entries: [] }),
}));
